import { Grid, Typography, useTheme } from "@mui/material";

import EmptyState from "components/EmptyState";
import { EmptyStateIcon } from "assets/Icon";
import HistoryBox from "./HistoryBox";
import NumberFormats from "components/NumberFormats";
import { TRADE_SIDE } from "../../constants";
import Table from "components/Table";
import TableSkeleton from "components/Skeletons/Table.skeleton";
import useIsMobileView from "hooks/useIsMobileView";
import { useSelector } from "react-redux";

const headers = [
  {
    key: "side",
    name: "Side",
    align: "left",
  },
  {
    key: "walletType",
    name: "Wallet Type",
    align: "center",
  },
  {
    key: "type",
    name: "Type",
    align: "center",
  },
  {
    key: "market",
    name: "Market",
    align: "center",
  },
  {
    key: "filled",
    name: "Amount",
    align: "center",
  },
  {
    key: "price",
    name: "Price",
    align: "center",
  },
  {
    key: "fee",
    name: "Fee",
    align: "center",
  },
  {
    key: "total",
    name: "Total",
    align: "center",
  },
  {
    key: "date",
    name: "Date",
    align: "center",
  },
];

function History24Log({ loading }) {
  const isMobileView = useIsMobileView();
  const theme = useTheme();

  const tradeHistory = useSelector((state) => state.trade.tradeHistory);

  const formattedItems = tradeHistory?.data?.map((item) => ({
    ...item,
    color:
      item?.sideId === TRADE_SIDE.Buy.id
        ? `${theme.palette.success.main}20`
        : `${theme.palette.error.main}20`,
    date: `${item?.date} ${item?.time}`,
    market: (
      <>
        <Typography variant="h6" component="span" color="text.main">
          {item?.coinSourceName}
        </Typography>
        /
        <Typography
          variant="subtitle1"
          component="small"
          color="text.secondary"
        >
          {item?.coinDestinationName}
        </Typography>
      </>
    ),
    side: (
      <Typography
        color={
          item?.sideId === TRADE_SIDE.Buy.id
            ? theme.palette.success.main
            : theme.palette.error.main
        }
        variant="h6"
      >
        {item?.side}
      </Typography>
    ),
    filled: (
      <Typography color="text.main" fontWeight={500} variant="h6">
        <NumberFormats value={item?.filled} />{" "}
        <Typography
          component="span"
          color="text.secondary"
          fontWeight={400}
          variant="subtitle1"
        >
          {item?.coinSourceName}
        </Typography>
      </Typography>
    ),
    fee: (
      <Typography color="text.main" fontWeight={500} variant="h6">
        <NumberFormats value={item?.fee} />{" "}
        <Typography
          component="span"
          color="text.secondary"
          fontWeight={400}
          variant="subtitle1"
        >
          {item?.coinFeeName}
        </Typography>
      </Typography>
    ),
    price: (
      <Typography color="text.main" fontWeight={500} variant="h6">
        <NumberFormats value={item?.price} />{" "}
        <Typography
          component="span"
          color="text.secondary"
          fontWeight={400}
          variant="subtitle1"
        >
          {item?.coinDestinationName}
        </Typography>
      </Typography>
    ),
    total: (
      <Typography color="text.main" fontWeight={500} variant="h6">
        <NumberFormats value={item?.total} />{" "}
        <Typography
          component="span"
          color="text.secondary"
          fontWeight={400}
          variant="subtitle1"
        >
          {item?.coinDestinationName}
        </Typography>
      </Typography>
    ),
  }));

  return (
    <>
      {isMobileView ? (
        <Grid container spacing={1}>
          {tradeHistory?.data?.length ? (
            tradeHistory?.data?.map((item) => (
              <Grid item xs={12}>
                <HistoryBox item={item} />
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <EmptyState
                text="No History"
                icon={<EmptyStateIcon color={theme.palette.text.secondary} />}
              />
            </Grid>
          )}
        </Grid>
      ) : (
        <>
          {!loading ? (
            <Table headers={headers} items={formattedItems} />
          ) : (
            <TableSkeleton />
          )}
        </>
      )}
    </>
  );
}

export default History24Log;
